/**
 * Opens a blob in a new browser tab.
 *
 * The actual `window.open` call is deferred to a macrotask so it doesn't run
 * synchronously inside a WebSocket message handler — opening the built-in PDF
 * viewer synchronously blocks the main thread and freezes the tab on large files.
 *
 * The object URL is revoked with a delay so the new tab has time to load it.
 */
export function openBlobInNewTab(blob: Blob): void {
  const url = window.URL.createObjectURL(blob);

  setTimeout(() => {
    window.open(url, '_blank');

    // Give the new tab time to load the resource before releasing it.
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  });
}
